import { AxiosInstance, AxiosRequestConfig } from "axios"

export interface GenerateShareLinkRequest extends Partial<AxiosRequestConfig> {
  data: {
    propertyId: string
    preQuoteId?: string | null
  }
}

export interface GenerateShareLinkResponseData {
  linkId: number
  token: string
  shareUrl: string
  propertyId: string
  expiresAt: string
}

export interface GenerateShareLinkResponse {
  apiStatus: string
  data: GenerateShareLinkResponseData
}

export function generateShareLinkApi(
  { data, ...config }: GenerateShareLinkRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: "/share-link/generate",
    data,
    ...config,
  }) as Promise<{ data: GenerateShareLinkResponse }>
}
